import Swiper, { Pagination } from 'swiper';

Swiper.use([Pagination]);

export default {

    inspirationSlider: () => {
        new Swiper('.inspiration-slider', {
            slidesPerView: 1,
            slideClass: 'cmeleon-block-content',
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
                clickable: true,
            },
        });
    },
};
